import '../App.css';

function AboutHero() {
    return (
        <div className="hero justify-start text-white font-rescue italic">
        <div className="flex flex-row items-center image-bg">
          {/* <img
            src={heroImage}
            className="max-w-sm rounded-lg shadow-2xl" /> */}
          <div className="flex flex-col items-center text-center p-20 font-bold w-full">
            {/* <img
            src={logo}
            className="max-w-sm rounded-lg shadow-2xl mt-10" /> */}
            <h1 className="text-2xl md:text-4xl">Our Services</h1>
          </div>
        </div>
      </div>
  );
}

export default AboutHero;
